function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m137.27 157.65c0-60.05 48.85-108.9 108.9-108.9 60.04 0 108.89 48.85 108.89 108.9v51.37h48.75v-51.37c0-86.93-70.72-157.65-157.64-157.65-86.93 0-157.65 70.72-157.65 157.65v51.37h48.75z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m455.12 239.02h-400.24c-11.05 0-20 8.95-20 20v230.98c0 11.05 8.95 20 20 20h400.24c11.05 0 20-8.95 20-20v-230.98c0-11.05-8.95-20-20-20zm-185.12 217.73c0 8.28-6.72 15-15 15s-15-6.72-15-15v-1.33c0-8.29 6.72-15 15-15s15 6.71 15 15zm2.05-72.09c-1.23.4-2.05 1.47-2.05 2.65v13.28c0 8.29-6.72 15-15 15s-15-6.71-15-15v-13.28c0-14.12 9.07-26.7 22.73-31.17 10.82-3.54 17.83-13.99 17.05-25.41-.85-12.25-10.73-22.13-22.99-22.98-14.63-1.03-26.63 10.55-26.63 24.78 0 8.27-6.69 15-15 15-8.28 0-15-6.72-15-15 0-31.06 26.18-56.95 58.7-54.71 27.12 1.87 48.98 23.73 50.85 50.85 1.73 25.15-13.75 48.17-37.66 55.99z"
});

var SvgForget = function SvgForget(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgForget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Forget.c39368af.svg";
export { ForwardRef as ReactComponent };